var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E37850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3482 5.04163H6.6515C5.99244 5.04163 5.36037 5.30344 4.89434 5.76947C4.42832 6.23549 4.1665 6.86756 4.1665 7.52663V12.4733C4.1665 13.1324 4.42832 13.7644 4.89434 14.2305C5.36037 14.6965 5.99244 14.9583 6.6515 14.9583H13.3482C13.6745 14.9583 13.9976 14.894 14.2991 14.7691C14.6006 14.6443 14.8746 14.4612 15.1053 14.2305C15.3361 13.9997 15.5191 13.7258 15.644 13.4243C15.7689 13.1228 15.8332 12.7996 15.8332 12.4733V7.52663C15.8332 6.86756 15.5714 6.23549 15.1053 5.76947C14.6393 5.30344 14.0072 5.04163 13.3482 5.04163ZM13.1965 8.48329L11.2773 10.1108C10.9204 10.4156 10.4663 10.5831 9.99692 10.5831C9.5275 10.5831 9.07347 10.4156 8.7165 10.1108L6.74484 8.48329C6.65588 8.40594 6.60129 8.29641 6.59309 8.17881C6.58488 8.06121 6.62373 7.94517 6.70109 7.85621C6.77844 7.76725 6.88797 7.71267 7.00557 7.70446C7.12317 7.69626 7.23921 7.7351 7.32817 7.81246L9.29984 9.45163C9.49925 9.62135 9.75256 9.71456 10.0144 9.71456C10.2763 9.71456 10.5296 9.62135 10.729 9.45163L12.654 7.82413C12.7427 7.74953 12.8571 7.71265 12.9727 7.72137C13.0883 7.73009 13.1958 7.78373 13.2723 7.87079C13.3403 7.96325 13.3704 8.07823 13.3563 8.19213C13.3422 8.30603 13.285 8.41022 13.1965 8.48329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.43214d5c038c70eb0d8344587b939490.svg";
export { ForwardRef as ReactComponent };